import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { LegendIconButton } from '../style/map_components';
import {
    Popover,
    Box,
    Typography,
    Stack,
    Collapse
} from '@mui/material';
import { Circle, ExpandMore } from '@mui/icons-material';

const MapSoilRainLegendIcon = () => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [legendOpen, setLegendOpen] = useState(false);
    const [soilRainOpen, setSoilRainOpen] = useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        console.log('handleClose')
        setAnchorEl(null);
    };

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    const legendItems = [
        { color: '#7a7a7a', label: '警戒レベル５相当'},
        { color: '#9d49c5', label: '警戒レベル４相当'},
        { color: '#fd5367', label: '警戒レベル３相当'},
        { color: '#faf500', label: '警戒レベル２相当'},
        { color: '#5c9fed', label: '警戒レベル１相当'},
    ];

    const ExpandableHeader = ({ label, expanded, toggle, sx = {} }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                mb: 0.5,
                ...sx,
            }}
            onClick={toggle}
        >
            <ExpandMore
                sx={{
                    transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                    transition: 'transform 0.2s',
                    fontSize: 16,
                    mr: 0.5,
                }}
            />
            <Typography sx={{ fontSize: '0.75rem' }}>{label}</Typography>
        </Box>
    );

    return (
        <>
            <LegendIconButton
                onClick={handleClick}>
                <InfoIcon sx={iconStyle} />
            </LegendIconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1, maxWidth: 200 }}>
                    {/* タイトル部：クリックで開閉 */}
                    <ExpandableHeader
                        label="凡例"
                        expanded={legendOpen}
                        toggle={() => setLegendOpen(!legendOpen)}
                    />
                    <Collapse in={legendOpen}>
                        <Box sx={{ pl: 2 }}>
                            {/* サブセクション */}
                            <ExpandableHeader
                                label="土壌雨量指数"
                                expanded={soilRainOpen}
                                toggle={() => setSoilRainOpen(!soilRainOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={soilRainOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {legendItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 60 }}>{item.label}</Typography>
                                            <Typography sx={{ fontSize: "10px", pl: 1, ml: '15px' }}>{item.threshold}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                    </Collapse>
                </Box>
            </Popover>
        </>
    );
};
export default MapSoilRainLegendIcon;